import React from "react";

/**
 * Layout publicznych stron, nie wymagajacych autoryzacji
 */
class PublicLayout extends React.Component {

    render() {
        return (
            <div className="publicLayout">
                {this.props.children}
            </div>
        );
    }

}

export default PublicLayout;
